import React from "react";
import {useIntl} from 'react-intl';
import PhoneInput from "react-phone-input-2";

function CustomPhoneInput(props) {
    const intl = useIntl();

    const handleOnChange = (phoneNumber) => {
        let finalPhoneNumber = phoneNumber;
        if (phoneNumber.indexOf("+") === -1 ) {
            finalPhoneNumber = "+" + finalPhoneNumber;

        }

        props.onChange(finalPhoneNumber);
    }

    return (
        <PhoneInput
            country="ro"
            international
            placeholder={intl.formatMessage({id: "EnterPhoneNumber"})}
            value={props.value}
            onChange={handleOnChange}
            searchPlaceholder={"Search"}
            enableSearch={true}
            disableSearchIcon={true}
            className="phone-input"
        />
    );

}


export default CustomPhoneInput;
